export var DOWNLOAD_ASSETS = 'DOWNLOAD_ASSETS';
export var DOWNLOAD_ASSETS_START = 'DOWNLOAD_ASSETS_START';
export var ASSETS_ZIP_CREATED = 'ASSETS_ZIP_CREATED';
export var ASSETS_ZIP_DOWNLOADED = 'ASSETS_ZIP_DOWNLOADED';
